var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccordionClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C10.3432 0 9.81081 0.53243 9.81081 1.18919V9.81085H1.18919C0.53243 9.81085 0 10.3432 0 11C0 11.6568 0.53243 12.1892 1.18919 12.1892H9.81081V20.8108C9.81081 21.4676 10.3432 22 11 22C11.6568 22 12.1892 21.4676 12.1892 20.8108V12.1892H20.8108C21.4676 12.1892 22 11.6568 22 11C22 10.3432 21.4676 9.81085 20.8108 9.81085H12.1892V1.18919C12.1892 0.53243 11.6568 0 11 0Z",
    fill: "#CB34FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionClosed);
export default __webpack_public_path__ + "static/media/accordion-closed.f625c2c9ca3c98aa05a85deb9300d701.svg";
export { ForwardRef as ReactComponent };